// extracted by mini-css-extract-plugin
export default {"header":"Top100_header__j3Qsb","item":"Top100_item__SC+sm"};